import React from 'react';
import { ProfileWhatsAppAccountsWidget } from './widget';

export const ProfileWhatsAppAccountsPage: React.FC = () => <ProfileWhatsAppAccountsWidget />;

